//import { utcParse, timeFormat } from 'd3-time-format'
import { NUMS } from '../utils/constants'

// export const makeDate = (month, day, year) => {
//   const m = month && month !== '00' ? MONTHS[month] : ''
//   const d = day ? ' ' + day : ''
//   const punc = day || (month && month !== '00') ? ', ' : ''
//   const y = year ? year : ''
//   const date = m + d + punc + y
//   return date ? date : 'Unknown'
// }
export const makeDate = (date, ui) => {
  const y = date.slice(0, 4)
  const m = date.slice(4, 6)
  const d = date.slice(6, 8)

  const dashedDate =
    y + '-' + (m !== '00' ? m : '04') + '-' + (d !== '00' ? d : '01')

  //new Date makes utc string, toLocaleDateString formats it
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'GMT'
  }
  const locale = ui === 'en' ? 'en-US' : 'fa-IR'
  const formattedDate = new Date(dashedDate).toLocaleDateString(locale, options)
  //if no month, return only year
  //if no day, return year and month
  //else return whole date

  //fa: order in array is day month year
  //en: order in array is month day year
  const dateArray = formattedDate.split(' ')
  if (m === '00') {
    return dateArray[2] //return just year
  } else if (d === '00') {
    return dateArray[ui === 'en' ? 0 : 1] + ' ' + dateArray[2] //return month and yeare
  }
  return formattedDate
}

export const getFaNum = (num) => {
  if (num < 10) return NUMS[num]
  //to handle multiple digit numbers
  const digitsToConvert = num.toString().split('')
  let numString = ''
  digitsToConvert.map((digit) => (numString += NUMS[digit]))
  return numString
}

// const parse = utcParse('%Y%m%d')
// const utcDate = parse('19930000')

// const formatDate = timeFormat('%B %e, %Y')
// console.log('format', formatDate(utcDate))
